import moment from 'moment';


export const DEV_MODE = false; //change here to local

export const YELLOW_THRESHOLD = 14;
export const GREEN_THRESHOLD = 35;

export const ENTRIES_PER_PAGE = 15;
export const ENTRIES_PER_PAGE_INVOICE = 25;

export const ageRanges = [
    { label: "18-25", value: 0 },
    { label: "25-30", value: 1 },
    { label: "30-35", value: 2 },
    { label: "35-40", value: 3 },
    { label: "40-45", value: 4 },
    { label: "45-50", value: 5 },
    { label: "50-55", value: 6 },
    { label: "55-60", value: 7 },
    { label: "60-65", value: 8 },
    { label: "65-70", value: 9 },
    { label: "70-80", value: 10 },
];

export const ageRangeToBirthday = (age) => {
    return moment().subtract(Number(ageRanges[age].label.substring(0,2)), 'years').format('YYYY-MM-DD');
}

export const birthdayToAgeRange = (bday) => {
    const age = Math.floor(moment(bday).diff(moment())/365.25);
    if (age < 25) {
        return 0;
    }
    if (age < 30) {
        return 1;
    }
    if (age < 35) {
        return 2;
    }
    if (age < 40) {
        return 3;
    }
    if (age < 45) {
        return 4;
    }
    if (age < 50) {
        return 5;
    }
    if (age < 55) {
        return 6;
    }
    if (age < 60) {
        return 7;
    }
    if (age < 65) {
        return 8;
    }
    if (age < 70) {
        return 9;
    }
    return 10;
}

export const germanLevels = [
    {label: "Anfänger/in", value: 0 },
    {label: "Mittelstufe", value: 1 },
    {label: "Mittelstufe +", value: 2 },
    {label: "Fortgeschritten", value: 3 },
    {label: "Fortgeschritten +", value: 4 },
    {label: "fließend", value: 5 },
];

export const ratings = [
    {label: "katastrophal", value: 0},
    {label: "ausreichend", value: 1},
    {label: "befriedigend", value: 2},
    {label: "gut", value: 3},
    {label: "sehr gut", value: 4},
];

export const tariffs = [
    {label: "Bronze light", value: 0},
    {label: "Bronze basic", value: 1},
    {label: "Silber", value: 2},
    {label: "Gold", value: 3},
];

export const additionalInvoiceServices = [
    {label: "Nicht gezahlte Leistungen Pflegekasse", value: 0, additional: true},
    {label: "Anteilige Grundpreiserhöhung", value: 1, additional: true},
    {label: "Anteil Beihilfe", value: 2, additional: true},
    {label: "Zusatzübergabe Betreuungskraft", value: 3, additional: true},
    {label: "Termin vor Ort", value: 4, additional: true}
];

export const substractionalInvoiceServices = [
    {label: "Leistungen Pflegekasse", value: 0, additional: false},
    {label: "Gutschrift", value: 1, additional: false},
    {label: "Bonus Kundenempfehlung", value: 2, additional: false},
    {label: "Tage ohne Betreuung", value: 3, additional: false},
    {label: "Mehrleistung Pflegekasse durch Erhöhung PG", value: 4, additional: false}
];

export const permissionTypes = [{value: 0, label: "einfacher Nutzer"}, {value: 1, label: "Nutzerverwaltung und Finanzen"}];

export const backendPathAuth = DEV_MODE ? "http://127.0.0.1:8000/auth/functions/" : "https://247.intranet.betreuung-mit-herz.org/backend/auth/functions/";
export const backendPathCustomers = DEV_MODE ? "http://127.0.0.1:8000/customers/" : "https://247.intranet.betreuung-mit-herz.org/backend/customers/";
export const backendPathEmployees = DEV_MODE ? "http://127.0.0.1:8000/employees/" : "https://247.intranet.betreuung-mit-herz.org/backend/employees/";
export const backendPathTasks = DEV_MODE ? "http://127.0.0.1:8000/tasks/" : "https://247.intranet.betreuung-mit-herz.org/backend/tasks/";
export const backendPathPartners = DEV_MODE ? "http://127.0.0.1:8000/partners/" : "https://247.intranet.betreuung-mit-herz.org/backend/partners/";
export const backendPathOfficeEmployees= DEV_MODE ? "http://127.0.0.1:8000/office-employees/" : "https://247.intranet.betreuung-mit-herz.org/backend/office-employees/";
export const backendPathAccounting = DEV_MODE ? "http://127.0.0.1:8000/accounting/" : "https://247.intranet.betreuung-mit-herz.org/backend/accounting/";
export const backendPathUsers = DEV_MODE ? "http://127.0.0.1:8000/users/" : "https://247.intranet.betreuung-mit-herz.org/backend/users/";
